import { defineMessages } from 'react-intl';

/** The texts of the extras box of a service row (design spotify-canvas d3). */
export const extrasMessages = defineMessages({
  hide: { id: 'app.sml.servicesPanel.extras.hide', defaultMessage: 'Hide' },
  show: { id: 'app.sml.servicesPanel.extras.show', defaultMessage: 'Show' },
});
